'use client'

import { forwardRef } from 'react'

import type { AnchorHTMLAttributes } from 'react'

import { useUIStore } from '@/stores/uiStore'
import type { ChildrenType } from '../types'

type RouterLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  Partial<ChildrenType> & {
    className?: string
  }

export const RouterLink = forwardRef((props: RouterLinkProps, ref: any) => {
  // Props
  const { href, className, children, onClick, ...other } = props

  // const [isPending, startTransition] = useTransition()
  const addOrFocusTab = useUIStore(state => state.addOrFocusTab)

  const handleAddTab = (href: string) => {
    const modul = href.split('#')[0]
    const label = href.split('#')[1]

    addOrFocusTab(modul, label)
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault() // Prevent default link behavior
    // startTransition(() => {
    onClick?.(e as any) // Call the original onClick if provided
    handleAddTab(href?.toString() ?? '#') // Add tab to localStorage
    // })
  }

  return (
    <a
      ref={ref}
      className={className}
      onClick={handleClick}
      href={href?.toString() ?? '#'}
      style={{ cursor: 'pointer' }}
      {...other}
    >
      {/* {isPending && <ProgressBar />} */}
      {children}
    </a>
  )
})
